<template>
  <!--***-->
  <div class="mx-4 mt-5" width="100%">
    <v-card
      :ripple="false"
      id="itemCard"
      elevation="0"
      outlined
      @click="$emit('click')"
      color="product_card"
      class="align-center text-start px-0"
    >
      <v-card-text class="pa-0 ma-0" style="">
        <!--***-->
        <v-list-item three-line class="px-2">
          <v-list-item-content class="py-1">
            <!--start item name-->
            <v-list-item-title
              @click="setCurrent()"
              class="font-weight-medium body-2 mb-0 product_name--text"
            >
              {{ item.name }}
            </v-list-item-title>
            <!--end item name-->

            <!--start item description-->
            <v-list-item-subtitle
              @click="setCurrent()"
              class="product_description--text"
              v-html="item.description"
            >
            </v-list-item-subtitle>
            <!--end item description-->

            <!--start item price-->
            <h6 @click="setCurrent()" class="font-weight-bold body-2">
              <span
                class="primary--text"
                v-if="
                  (isDelivery
                    ? itemGroup['delivery discount']
                    : itemGroup['takeaway discount']) &&
                    (isDelivery
                      ? itemGroup['delivery discount']
                      : itemGroup['takeaway discount'])
                "
              >
                {{ itemPrice.afterDiscount | currency }}
              </span>
              <span
                class="text-muted"
                :class="{
                  'text-decoration-line-through text-muted':
                    itemGroup &&
                    (isDelivery
                      ? itemGroup['delivery discount']
                      : itemGroup['takeaway discount']) > 0,
                  'primary--text': !(
                    itemGroup &&
                    (isDelivery
                      ? itemGroup['delivery discount']
                      : itemGroup['takeaway discount']) > 0
                  )
                }"
              >
                {{ itemPrice.original | currency }}
              </span>
            </h6>
            <!--end item price-->

            <!--start deposit info-->
            <div
              v-if="enableDeposit && itemDeposit > 0"
              class="text-muted caption"
            >
              {{ $t("delivery.lang_includeDeposit") }}
              {{ itemDeposit | currency }}
            </div>
            <!--end deposit info-->

            <!--start Produktinfo-->
            <div
              style="display: inline-block; width: fit-content !important;"
              v-if="!productInfoSettings.hideProductInfo"
            >
              <p
                @click="details"
                class="accent--text small"
                style="width: auto; display: inline-block; cursor: pointer;"
              >
                {{ $t("delivery.lang_productInfo") }}
              </p>
            </div>
            <!--end Produktinfo-->
          </v-list-item-content>

          <!--start item image-->
          <v-list-item-avatar
            class="my-auto"
            @click="setCurrent()"
            :size="$vuetify.breakpoint.xs ? 60 : 80"
            tile
          >
            <v-avatar
              circle
              :size="$vuetify.breakpoint.xs ? 60 : 80"
              color="transparent"
            >
              <img v-if="item.image" :src="item.image" height="120" />
              <img
                v-else
                :src="images && images.productDefaultImage"
                height="120"
              />
            </v-avatar>
          </v-list-item-avatar>
          <!--end item image-->

          <!--start close and open or plus button-->
          <v-list-item-action>
            <v-btn
              elevation="0"
              min-width="30"
              min-height="30"
              dark
              absolute
              color="accent"
              class="position-absolute item_btn"
              @click="setCurrent()"
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>
          </v-list-item-action>
          <!--start close and open or plus button-->
        </v-list-item>
        <!--***-->
      </v-card-text>
    </v-card>
    <!--start product-info-dialog-->
    <product-info-dialog
      v-model="details_dialog"
      :dialog="this.details_dialog"
      :item="this.item"
    />
  </div>
  <!--end product-info-dialog-->
</template>

<script>
import itemBooking from "@/mixins/itemBooking";
import ProductInfoDialog from "@/components/Menu/ProductInfoDialog";

export default {
  name: "MenuItemsCard",

  components: { ProductInfoDialog },

  mixins: [itemBooking],

  data() {
    return {
      details_dialog: false,
      text:
        "ist momentan geschlossen. Bitte versuche es morgen wieder oder wähle ein anderes Restaurant."
    };
  },

  methods: {
    //show product details dialog
    details() {
      this.details_dialog = true;
    },

    //call this function on click on item card
    setCurrent() {
      if (this.isDelivery && !this.maintenanceMode) {
        if (this.offersDelivery) {
          if (!this.deliveryInfo) {
            this.$root.$emit("toggleDeliveryAreaDialog", true);
            return;
          }
        }
      }

      if (!this.maintenanceMode) {
        this.checkExtrasAndSizes();
      }
    },

    //check if item congtain extras and sizes, booking happens in the global dialog
    checkExtrasAndSizes() {
      if (
        (Array.isArray(this.item.sizes) && this.item.sizes.length > 0) ||
        (Array.isArray(this.item.extras) && this.item.extras.length > 0)
      ) {
        this.resetBooking();
        this.$emit("book", { item: this.item, itemGroup: this.itemGroup });
      } else {
        this.addToCart();
      }
    }
  }
};
</script>

<style scoped>
.item_btn {
  position: absolute !important;
  top: -1px !important;
  right: -1px;
  max-width: 20px !important;
  max-height: 20px !important;
}
</style>
